export default __webpack_public_path__ + "static/media/filled2.d94345c9.svg";